var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg999(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 34,
    viewBox: "0 0 52 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1101_962)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.933 25.389C28.9098 29.397 24.8111 32.2564 19.6368 33.9672C18.7725 33.9672 18.2262 33.792 18.0186 33.4642L15.5361 30.5867C14.9568 29.9152 15.1698 29.2542 16.1788 28.5925C20.4302 25.8586 22.9471 22.4234 23.7296 18.2869C21.0737 17.9847 18.9477 17.0282 17.3685 15.4027C15.7894 13.7771 14.9971 11.7463 14.9971 9.30648C14.9971 6.36246 15.9646 4.02397 17.9075 2.32153C19.6289 0.779012 21.9698 0.00195474 24.9199 0.00195474C28.4347 0.000328598 31.2192 1.224 33.2734 3.67298C35.3195 6.12928 36.3452 9.39926 36.3505 13.4829C36.3505 17.5589 34.878 21.5276 31.933 25.389Z",
    fill: "#97989E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0814 21.8982C9.10614 24.5205 6.4248 26.3914 3.03741 27.5109C2.47156 27.5109 2.11386 27.3961 1.97713 27.1819L0.354039 25.3C-0.0256374 24.8605 0.114147 24.4289 0.773393 23.9943C3.55606 22.2038 5.20418 19.9558 5.71774 17.2505C3.97989 17.0539 2.58815 16.4282 1.55594 15.3649C0.523734 14.3016 0 12.9721 0 11.3759C0 9.44939 0.634219 7.91909 1.90632 6.80447C3.03192 5.7979 4.56284 5.28516 6.49418 5.28516C8.793 5.28516 10.6194 6.08541 11.9586 7.68774C13.2978 9.29008 13.973 11.4357 13.973 14.1087C13.973 16.7817 13.0079 19.3698 11.0814 21.8982Z",
    fill: "#97989E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.012 21.8982C47.0351 24.5205 44.3535 26.3914 40.9673 27.5109C40.4009 27.5109 40.0432 27.3961 39.904 27.1819L38.2846 25.3C37.9043 24.8605 38.0459 24.4289 38.7033 23.9943C41.4803 22.2038 43.1284 19.9558 43.6477 17.2505C41.9092 17.0539 40.5222 16.4254 39.4865 15.3649C38.4488 14.3046 37.9336 12.9721 37.9336 11.3759C37.9336 9.44939 38.5666 7.91909 39.8375 6.80447C40.9619 5.7979 42.4879 5.28516 44.418 5.28516C46.7237 5.28516 48.5472 6.08602 49.8885 7.68774C51.2278 9.29557 51.8992 11.4359 51.9029 14.1087C51.9029 16.7741 50.9395 19.3706 49.0126 21.8982",
    fill: "#97989E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1101_962"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 34,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg999);
export default __webpack_public_path__ + "static/media/999.2fd7b3c0013afeb2e3196ac8f58b0cf5.svg";
export { ForwardRef as ReactComponent };